import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {ReflexiveRestModel} from '../../../lib/reflexive-model/reflexive-rest-model';
import {FormGroup} from '@angular/forms';
import {FieldDefinition} from '../../../lib/reflexive-model/field-definition';

@Component({
  selector: 'app-field-group',
  templateUrl: './field-group.component.html',
})
export class FieldGroupComponent implements OnInit {
  @HostBinding('class.form__base-field-group') fieldGroupComponent = true;
  @Input() model: ReflexiveRestModel;
  @Input() fieldGroup: FieldDefinition;
  @Input() formGroup: FormGroup;
  @Input() fieldNames: Array<string>;

  constructor() {
  }
  showField(fieldName: string): boolean {
    return this.model.fields[fieldName] &&
      (!this.model.fields[fieldName].isVisible || this.model.fields[fieldName].isVisible(this.formGroup));
  }

  ngOnInit() {
  }

}
